import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import PortfolioBlog from "./pages/PortfolioBlog";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import AboutTerminal from "./pages/AboutTerminal";
import ContactTerminal from "./pages/ContactTerminal";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  // const [loaded, setLoaded] = useState(false);
  // useEffect(() => {
  //   const nav = document.querySelector("nav");
  //   const handleScroll = () => {
  //     if (window.scrollY > 10) {
  //       nav.classList.add("shadow-md");
  //     } else {
  //       nav.classList.remove("shadow-md");
  //     }
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);
  return (
    <>
      <Router>
        <ScrollToTop />
        <div className="font-mono">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/portfolio-blog" element={<PortfolioBlog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about-terminal" element={<AboutTerminal />} />
            <Route path="/contact-terminal" element={<ContactTerminal />} />
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
